module.exports = __webpack_public_path__ + "static/media/application-pdf.82e47f50.svg";